import { render, staticRenderFns } from "./ViewProfile.vue?vue&type=template&id=270035c9&scoped=true"
import script from "./ViewProfile.vue?vue&type=script&lang=ts"
export * from "./ViewProfile.vue?vue&type=script&lang=ts"
import style0 from "./ViewProfile.vue?vue&type=style&index=0&id=270035c9&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "270035c9",
  null
  
)

export default component.exports